<template>
  <section>
    <div class="searchBar">
      <!-- <div class="box-ui-select searchbar-content">
        <div class="title">
          <span>회원등급</span> :
        </div>
        <select class="reqMember" v-model="reqData.memLevel">
          <option value="">전체</option>
          <option v-for="idx in 5" :key="idx" :value="idx">{{ "레벨" + idx }}</option>
        </select>
      </div> -->
      <div class="box-ui-select searchbar-content">
        <div class="title">
          <span>회사선택</span> :
        </div>
        <input type="text" class="mr-5" v-model.trim="reqData.siteId" placeholder="회사 ID 입력"/>
        <!-- <select class="reqMember" v-model="reqData.companyName">
          <option value="">회사선택</option>
          <option value="winner">위너</option>
          <option value="sportbet">스포뱃</option>
        </select> -->
      </div>
      <div class="box-ui-select searchbar-content">
        <div class="title"><span>가입일</span> :</div>
        <date-selector :class="'searchbar-content'" @setStartDate="setStartDate" @setEndDate="setEndDate" />
      </div>
      <div class="box-ui-select searchbar-content">
        <div class="title"><span>윈루즈&입출금 차액</span> :</div>
        <date-selector :class="'searchbar-content'" @setStartDate="setWlStartDate" @setEndDate="setWlEndDate" />
      </div>
    </div>
    <div class="searchBar">
      <div :class="'searchbar-content'">
        <div class="title"><span>조건</span> :</div>
        <select class="mr-5" v-model="searchOptionText.option">
          <option value="memId">아이디</option>
          <option value="recommenderId">추천인아이디</option>
        </select>
        <input type="text" class="mr-5" v-model="searchOptionText.text" />
        <button class="btn-search" type="button" @click="pageSeach">
          검색
        </button>
      </div>
      <div class="box-ui-check searchbar-content" v-if="selectOption === 'option'">
        <div class="toggle-container">
          <div class="toggle-item">
            <span class="toggle-title">삭제회원포함</span>
            <input type="checkbox" class="set-switch" v-model="optionCheck.memDelYn" />
          </div>
        </div>
        <div class="toggle-container">
          <div class="toggle-item">
            <span class="toggle-title">블랙리스트 포함</span>
            <input type="checkbox" class="set-switch" v-model="blackYn" />
          </div>
        </div>
      </div>
    </div>
    <div class="main-contents-wrapper">
      <article class="total-info-container">
        <div class="total-info-wrap">
          <div class="total-info-item">
            <img :src="require('@/assets/img/searchicon.png')" />
            검색
            <span>검색결과</span>
          </div>
          <template v-for="(value, key) in totalInfo" :key="key">
            <div class="total-info-item">
              <span class="title">{{ $t(`totalInfo.${key}`) }}</span> : <span class="value">{{ value }}</span>
            </div>
          </template>
        </div>
        <button type="button" class="btn-layout" :class="wlContentsActive ? 'btn-red' : 'btn-blue'" @click="wlContentsToggle">윈루즈 {{ wlContentsActive ? "닫기" : "열기" }}</button>
      </article>
      <div class="table-wrapper">
        <table class="mainTable">
          <table-head :headInfo="headInfo" />
          <tbody>
            <tr v-if="!reqData.siteId">
              <td :colspan="headInfo.dataList.length">회사 ID를 입력한 후 검색해주세요.</td>
            </tr>
            <tr v-for="(item, idx) in memList" :key="idx">
              <td>
                <span>{{ Number(this.pageInfo.tatal_list_count) - ((this.pageInfo.page - 1) * 30 + idx) }}</span>
              </td>
              <td>
                <button type="button" class="fc-id btn-link" @click="openDetail_user(item.memId)">{{ item.memId }}</button>
              </td>
              <td>
                <span class="fc-nick">{{ item.memNick }}</span>
              </td>
              <td>{{ item.memName }}</td>
              <td>{{ item.recommenderId }}</td>
              <!-- <td>{{ item.recommenderNick }}</td> -->
              <td>{{ item.totalLoginCount }}</td>
              <td>{{ item.totalCashInAmt }}</td>
              <td>{{ item.totalBonusAmt }}</td>
              <td>{{ item.totalCashOutAmt }}</td>
              <td>{{ item.totalCashDiff }}</td>
              <td>{{ item.cashAmt }}</td>
              <td>{{ item.pointAmt }}</td>
              <td>{{ item.totalWlAmt }}</td>
              <td v-if="wlContentsActive">{{ item.casinoWlAmt }}</td>
              <td v-if="wlContentsActive">{{ item.eSportsWlAmt }}</td>
              <td v-if="wlContentsActive">{{ item.mgWlAmt }}</td>
              <td v-if="wlContentsActive">{{ item.slotWlAmt }}</td>
              <td v-if="wlContentsActive">{{ item.sportsWlAmt }}</td>
              <td v-if="wlContentsActive">{{ item.kgWlAmt }}</td>
              <td>{{ item.regDt }}</td>
              <td>{{ item.lastLoginDt }}</td>
              <td>{{ item.loginIp }}</td>
              <td>
                <div class="btn-wrap">
                  <button type="button" class="btn-innerTable btn-status-change refuse btn-link" @click="deleteMember(item.memId)">삭제</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination v-if="memList.length !== 0" @goPage="pageSeach" :pageNum="pageInfo.page" :pageSize="pageInfo.count_per_list" :totalCount="pageInfo.tatal_list_count" />
  </section>
</template>

<script>
// import SearchBar from '@/components/main/top/SearchBar.vue'
import TableHead from "@/components/main/table/Head.vue";
import BtnVisibleToggle from "@/components/ui/BtnVisibleToggle";
import SearchFilter from "@/components/common/SearchFilter";
import DateSelector from "@/components/common/DateSelector";
import Pagination from "@/components/common/Pagination";
import UiSelect from "@/components/ui/Select";
import UiCheckSet from "@/components/ui/UiCheckSet";
import UiCheck from "@/components/ui/UiCheck";
import { getSiteData, getAuthToken, removeAuthData } from "@/libs/auth-helper";
import { companyList, compMemberList,companyStatistics, retailList,superMemberList } from "@/api/company.js";
import { replceDateT, numberWithCommas, getDateStr } from "@/libs/utils.js";

export default {
  name: "UserList",
  components: {
    UiSelect,
    UiCheckSet,
    UiCheck,
    BtnVisibleToggle,
    TableHead,
    // BtnHideOpen,
    SearchFilter,
    Pagination,
    DateSelector
  },
  data() {
    return {
      tableName: this.$route.name,
      headInfo: {
        fstColumn: false,
        dataList: [
          "index",
          "memId",
          "memNick",
          "memName",
          "recommenderId",
          "totalLoginCount",
          "totalCashInAmt",
          "bonusAmt",
          "totalCashOutAmt",
          "totalCashDiff",
          "cashAmt",
          "pointAmt",
          "wl",
          "memRegDt",
          "lastLoginDt",
          "lastLoginIp",
          "delete"
        ]
      },
      selectOption: "option",
      reqData: {
        page: 1,
        count_per_list: 30,
        count_per_page: 30,
        siteId: "",
        recommenderId: "",
        memLevel: "",
        memId: "",
        startDate: "",
        endDate: "",
        memStatus: "1",
        memDelYn: "N",
        memBlackYn: "N",
        companyName: ""
      },
      optionCheck: {
        loginYn: true,
        betYn: true,
        recommendYn: true,
        memDelYn: false
      },
      blackYn: false,
      additionalHead: ["casino", "eSports", "game", "slot", "sports", "kGame"],
      srchFiltersProp: {
        selectOptions: [
          {
            useAll: false,
            opts: [
              {
                text: "id",
                value: "memId"
              },
              {
                text: "recommenderId",
                value: "recommenderId"
              }
            ]
          }
        ]
      },
      selectOptions: [
        {
          useAll: true,
          opts: [
            {
              title: "subUser",
              orders: ["many", "few"]
            }
          ]
        }
      ],
      checkList: [
        {
          name: "loginYn",
          checked: true,
          text: "로그인가능"
        },
        {
          name: "betYn",
          checked: true,
          text: "베팅가능"
        },
        {
          name: "recommenderYn",
          checked: true,
          text: "추천가능"
        },
        {
          name: "recommenderYn",
          checked: true,
          text: "추천가능"
        }
      ],
      searchOptionText: {
        option: "memId",
        text: ""
      },
      tableData: [],
      btnText: "보기",
      memList: [],
      pageInfo: {},
      totalInfo: {},
      seniorList:{},
      wlContentsActive: false
    };
  },

  watch: {
    selectOption: function (val) {
      switch (val) {
        case "all":
          (this.reqData.betYn = ""), (this.reqData.recommendYn = ""), (this.reqData.todayLoginYn = ""), (this.reqData.loginYn = ""), (this.reqData.memDelYn = ""), (this.reqData.todayLoginYn = "");
          break;
        case "option":
          // this.optionCheck.betYn=true,
          // this.optionCheck.recommendYn=true,
          // this.optionCheck.todayLoginYn=true,
          // this.optionCheck.loginYn=true,
          // this.optionCheck.memDelYn=false,
          this.reqData.todayLoginYn = "";
          break;
        case "loginY":
          (this.reqData.betYn = ""), (this.reqData.recommendYn = ""), (this.reqData.todayLoginYn = ""), (this.reqData.loginYn = "Y"), (this.reqData.memDelYn = "N"), (this.reqData.todayLoginYn = "");
          break;
        case "loginN":
          (this.reqData.betYn = ""), (this.reqData.recommendYn = ""), (this.reqData.todayLoginYn = ""), (this.reqData.loginYn = "N"), (this.reqData.memDelYn = "N"), (this.reqData.todayLoginYn = "");
          break;
        case "betY":
          (this.reqData.betYn = "Y"), (this.reqData.recommendYn = ""), (this.reqData.todayLoginYn = ""), (this.reqData.loginYn = ""), (this.reqData.memDelYn = "N"), (this.reqData.todayLoginYn = "");
          break;
        case "betN":
          (this.reqData.betYn = "N"), (this.reqData.recommendYn = ""), (this.reqData.todayLoginYn = ""), (this.reqData.loginYn = ""), (this.reqData.memDelYn = "N"), (this.reqData.todayLoginYn = "");
          break;
        case "recommendY":
          (this.reqData.betYn = ""), (this.reqData.recommendYn = "Y"), (this.reqData.todayLoginYn = ""), (this.reqData.loginYn = ""), (this.reqData.memDelYn = "N"), (this.reqData.todayLoginYn = "");
          break;
        case "recommendN":
          (this.reqData.betYn = ""), (this.reqData.recommendYn = "N"), (this.reqData.todayLoginYn = ""), (this.reqData.loginYn = ""), (this.reqData.memDelYn = "N"), (this.reqData.todayLoginYn = "");
          break;
        case "delYn":
          (this.reqData.betYn = ""), (this.reqData.recommendYn = ""), (this.reqData.todayLoginYn = ""), (this.reqData.loginYn = ""), (this.reqData.memDelYn = ""), (this.reqData.todayLoginYn = "");
          break;
        case "todayLoginY":
          (this.reqData.betYn = ""), (this.reqData.recommendYn = ""), (this.reqData.todayLoginYn = ""), (this.reqData.loginYn = ""), (this.reqData.memDelYn = "N"), (this.reqData.todayLoginYn = "Y");
          break;
      }
    }
  },
  methods: {
    goSearch(){
      if(this.reqData.siteId){
        this.tableData(1);
      }else{
        alert('검색하실 회사명을 입력해주세요.')
      }
    },
    getSiteInfo() {
      const siteInfoCookie = getSiteData();
      if (siteInfoCookie) {
        const siteInfo = JSON.parse(siteInfoCookie);
        return siteInfo;
      }
    },
    setStartDate(date) {
      console.log(date[0]);
      this.reqData.startDate = getDateStr(date[0], "yyyy-MM-dd");
    },
    setEndDate(date) {
      console.log(date[0]);
      this.reqData.endDate = getDateStr(date[0], "yyyy-MM-dd");
    },
    setWlStartDate(date) {
      console.log(date[0]);
      this.reqData.wlStartDate = getDateStr(date[0], "yyyy-MM-dd");
    },
    setWlEndDate(date) {
      console.log(date[0]);
      this.reqData.wlEndDate = getDateStr(date[0], "yyyy-MM-dd");
    },
    async deleteMember(memId) {
      const reqData = {
        memId: memId,
        memDelYn: "Y"
      };
      const res = await memberModify(reqData);
      if (res.resultCode === "0") {
        alert("회원삭제 완료");
      } else {
        alert("삭제 실패, 다시 시도해주세요.");
      }
      this.setTableData(1);
    },
    pageSeach() {
      if (!this.reqData.siteId) {
        alert("회사를 선택해주세요.");
        return;
      }
      if (this.selectOption === "option") {
        for (const item in this.optionCheck) {
          if (this.optionCheck[item]) {
            if (item === "memDelYn") {
              this.reqData[item] = "";
            } else {
              this.reqData[item] = "Y";
            }
          } else {
            this.reqData[item] = "N";
          }
        }
      }
      if (this.blackYn) {
        this.reqData.memBlackYn = "";
      } else {
        this.reqData.memBlackYn = "N";
      }
      if (!this.searchOptionText.text) {
        this.reqData.memId = "";
        this.reqData.recommenderId = "";
      } else {
        if (this.searchOptionText.option === "memId") {
          this.reqData.memId = this.searchOptionText.text;
          this.reqData.recommenderId = "";
        } else if (this.searchOptionText.option === "recommenderId") {
          this.reqData.memId = "";
          this.reqData.recommenderId = this.searchOptionText.text;
        }
      }

      this.setTableData(1);
    },
    wlContentsToggle() {
      const reverseArr = this.additionalHead.reverse();
      const addPosition = this.headInfo.dataList.indexOf("wl") + 1;
      this.wlContentsActive = !this.wlContentsActive;
      for (const item of reverseArr) {
        if (this.wlContentsActive) {
          this.headInfo.dataList.splice(addPosition, 0, item);
        } else {
          this.headInfo.dataList.splice(addPosition, 1);
        }
      }
    },
    openDetail_user(memId) {
      const routeData = this.$router.resolve({ name: "userDetail", query: { id: memId } });
      window.open(routeData.href, "newpage", "top=0,left=150,scrollbars=no,resizable=no,width=1435,height=815,status=no");
    },
    openDetail_partner() {
      // console.log(id)
    },
    async getSeniors(){
      const req = {}
      const res = await companyStatistics(req);
    },
    async setTableData(pageNum) {
      if (!getAuthToken()) {
        removeAuthData();
        this.$router.replace({ name: "login" });
        return;
      }
      this.reqData.siteId = this.reqData.siteId.trim();
      if (!this.reqData.siteId) {
        alert("회사 ID를 입력해주세요.");
        return;
      }
      if (pageNum) {
        this.reqData.page = pageNum;
      }
      const data = this.reqData;
      let listRes;
      try {
        listRes = await superMemberList(data);
      } catch (error) {
        this.memList = [];
        this.pageInfo = {};
        this.totalInfo = {};
        if (!error.isHandled) alert("회원 목록을 불러오지 못했습니다.");
        return;
      }
      if (listRes.resultCode !== "0") {
        this.memList = [];
        this.pageInfo = {};
        this.totalInfo = {};
        alert(listRes.resultMessage || "회원 목록을 불러오지 못했습니다.");
        return;
      }
      const pageInfo = listRes.data.pageInfo;
      this.pageInfo = pageInfo;
      const totalInfo = listRes.data.totalInfo;
      this.totalInfo = totalInfo;
      const memList = listRes.data.list;
      memList.forEach(items => {
        for (const item in items) {
          if (item === "regDt" || item === "lastLoginDt") {
            items[item] = replceDateT(items[item]);
          }
          if (!isNaN(Number(items[item]))) {
            items[item] = numberWithCommas(items[item]);
          }
        }
      });
      this.memList = memList;
    }
  },
  async created() {
    this.siteInfo = await this.getSiteInfo();
    // this.getSeniors();
    // Wait for an explicit company selection before requesting members.
  }
};
</script>

<style scoped>
.active .btn-t-inner {
  display: none;
}
.fstColumn.userList .levelColor {
  display: block;
}

.box-hideOpen .levelColor {
  background: rgb(255, 218, 38);
  width: 8px;
}
</style>
